import React from "react";

function Home() {
  return (
    <div>
      <h1>I am in Home Page</h1>
    </div>
  );
}

export default Home;
